
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存

// 批量保存
export const saveBatch = (data) => {
    return axios({
        url: '/tblTempExcelImportOutbound/saveBatch',
        method: 'post',
        data
    })
}
export const save = (data) => {
    return axios({
        url: '/tblTempExcelImportOutbound/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblTempExcelImportOutbound/delete',
        method: 'post',
        data
    })
}
// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblTempExcelImportOutbound/findPage',
        method: 'post',
      data
    })
}
// 导入Excel
export const importExcel = (data) => {
  return axios({
    url: '/tblTempExcelImportOutbound/importExcel',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblTempExcelImportOutbound.js